<template>
    <div class="nav">
        <div class="logo">
            <img class="bgImage" src="@/images/mobile/home/1-1new.png" alt="" />
        </div>
        <div class="menu" @click="menuClick">
            <img class="bgImage" src="@/images/mobile/home/1-2.png" alt="" />
        </div>
        <!-- 侧边导航(整页弹框) -->
        <div v-show="navMaskShow" class="navMask" @click="navMaskClick">
            <div class="slideNavbar" :class="slideNavbarShow?'slideNavbar_active':''" @click="slideNavbarClick">
                <div class="navCon">
                    <router-link exact :to="item.path" custom v-slot="{ navigate }" v-for="(item,index) in this.$router.options.routes" :key="index">
                        <div class="navBox"  @click="navigate">
                            <div class="hexian" :class="$store.state.navCurrentIndex == item.meta.id?'nav_active_hexian':''"></div>
                            <div class="wenzi" :class="$store.state.navCurrentIndex == item.meta.id?'nav_active_wenzi':''">{{$store.state.i18n?item.meta.title:item.meta.title_en}}</div>
                            <div class="hexian" :class="$store.state.navCurrentIndex == item.meta.id?'nav_active_hexian':''"></div>
                        </div>
                    </router-link>
                </div>
                <div class="loginBox">
                   <!-- <div @click="onLogin()" class="login box">{{$store.state.i18n?'登录':'Login'}}</div>
                    <div @click="onRegister()" class="register box">{{$store.state.i18n?'注册':'Register'}}</div> -->
                </div>
                <div class="cnorBox">
                    <div class="CnorEn" @click="CNorENClick()">
                        <img v-show="$store.state.i18n" class="bgImage" :src="componentsLang.phone.chinese.nav.img" />
                        <img v-show="!$store.state.i18n" class="bgImage" :src="componentsLang.phone.english.nav.img" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
// 引入相关接口
import {loginRedirect} from '@/api/login.js'
export default {
    inject: ['reload'],
    data(){
        return {
            // 导航弹框是否显示
            navMaskShow:false,
            slideNavbarShow:false,
            loginUrl:'',   //登录重定向地址
            registerUrl:'' //注册重定向地址
        }
    },
    created(){
       //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store") ) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
      }
      //在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload",()=>{
        sessionStorage.setItem("store",JSON.stringify(this.$store.state))
      })
    },
    mounted(){
        // 在一开始获取路由信息
      let id = this.$route.meta.id;
      this.$store.commit('setNavCurrentIndex',id);

      // 获取登录，注册的重定向地址
      loginRedirect({
        data: {
          hideLoading: true
        },
        head: {
          terminalCode: "jdh_ent",
        },
      }).then((res) => {
        this.loginUrl = res.data.data.loginUrl;
        this.registerUrl = res.data.data.registerUrl;
      })
    },
    methods:{
        // 登录
        onLogin(){
            window.location.href = this.loginUrl;       //当前标签页
            //  window.open(src);          //打开一个新的标签页
        },
        // 注册
        onRegister(){
            window.location.href = this.registerUrl; 
        },
        // 顶部菜单按钮点击
        menuClick(){
            this.navMaskShow = true;
            setTimeout(() => {
                this.slideNavbarShow = true;
            },300)
        },
        // 蒙层点击
        navMaskClick(){
            this.navMaskShow = false;
            this.slideNavbarShow = false;
        },
        // 左侧导航点击
        slideNavbarClick(e){
            // 阻止事件的冒泡行为
            if (e && e.stopPropagation){
                e.stopPropagation()
            }else{
                window.event.cancelBubble = true
            }
            this.navMaskShow = true;
            this.slideNavbarShow = true;
        },
        // 中英文切换
        CNorENClick(){
			let val = 0
			val++;
            this.$emit('loadingShowClick',true);
            setTimeout(()=>{
                this.$store.commit('setI18n');
				this.$store.commit('getVal');
				// 定义手机系统
				let agent = navigator.userAgent.indexOf('iPhone') > -1;
				if(agent){
				    this.reload();
				}else{
				    this.$router.go(0);
				}
            },1500)
        }
    },
    watch:{
      $route(to,from){
        this.$store.commit('setNavCurrentIndex',to.meta.id);
      }
    }
}
</script>


<style scoped>
.bgImage{
    width:100%;height:100%;
    position: absolute;
    left:0;top:0;
}
.nav{
    width:100vw;height:12.66vw;
    background-color: #f8f9fb;
    border-bottom:1px solid #dcdddf;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left:5.33vw;
    padding-right:5.33vw;
}
.nav .logo{
    width: 32.4vw;
    height: 5.06vw;
    position: relative;
}
.nav .menu{
    width:4.93vw;height:4.13vw;
    position: relative;
}


/* 导航弹框 */
.navMask{
    width:100vw;height:100vh;
    position: fixed;
    left:0;top:0;
    background-color: rgba(0,0,0,0.5);
    z-index: 9999;
}
.navMask .slideNavbar{
    width:34vw;height:100%;
    position:relative;
    background-color: white;
    transform: translateX(-50vw);
    transition: 0.6s;
    box-sizing: border-box;
    padding-top:10vw;
}
.navMask .slideNavbar .navCon{
    width:100%;height:112vw;
    /* background-color: aquamarine; */
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}
.navMask .slideNavbar .navCon .navBox{
    width:auto;height:10.66vw;
    /* background-color: blueviolet; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}
.navMask .slideNavbar .navCon .navBox .hexian{
    width:0px;height:1vw;
    background-color:#c22c33;
    transition: 0.1s;
}
/* .navMask .slideNavbar .navCon .navBox .wenzi{
  width:100%;height:2.083vw;
  padding-top:0.521vw;
  padding-bottom:0.521vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size:0.938vw;
  color:#212529;
  font-weight:normal;
} */
.navMask .slideNavbar_active{
    transform: translateX(0);
}

/* 导航栏选中样式 */
.navMask .slideNavbar .navCon .navBox:hover .hexian{
  width:100%;
}
.navMask .slideNavbar .navCon .navBox:hover .wenzi{
  color:#000;
  font-weight:bold;
}

/* 导航栏索引选中样式 */
.navMask .slideNavbar .navCon .navBox .nav_active_hexian{
  width:100%;
}
.navMask .slideNavbar .navCon .navBox .nav_active_wenzi{
  color:#000;
  font-weight:bold;
}


.navMask .slideNavbar .loginBox{
    width:100%;height:25vw;
    /* background: aquamarine; */
    margin-top:7vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}
.navMask .slideNavbar .loginBox .box{
    width:18vw;height:10vw;
    /* background-color: orange; */
    font-weight:bold;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius:2vw;
    color:#c6151d;
    user-select: none;
    
}
.navMask .slideNavbar .loginBox .box:hover{
    background-color: #f2e5e6;
    border:1px solid #c6151d;
}

.navMask .cnorBox{
    width:100%;height:5.6vw;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:8vw;
}
.navMask .cnorBox .CnorEn{
    width:5.86vw;height:6vw;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/mobileNav/index.vue